import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * 派对星球
 */
var copyrightCollect = {
  path: '/partyPlanet',
  component: RootLayout,
  redirect: '/partyPlanet',
  children: [{
    path: '/partyPlanet',
    name: 'PartyPlanet',
    component: function component() {
      return import('views/partyPlanet/Index');
    },
    meta: {
      title: '派对星球',
      keepAlive: true
    }
  }, {
    path: '/partyPlanet/detail',
    name: 'PartyPlanetDetail',
    component: function component() {
      return import('views/partyPlanet/Detail');
    },
    meta: {
      title: '派对星球'
    }
  }, {
    path: '/partyPlanet/sponsor',
    name: 'PartyPlanetSponsor',
    component: function component() {
      return import('views/partyPlanet/Sponsor');
    },
    meta: {
      title: '发起人'
    }
  }, {
    path: '/partyPlanet/apply',
    name: 'PartyPlanetApply',
    component: function component() {
      return import('views/partyPlanet/Apply');
    },
    meta: {
      title: '活动报名'
    }
  }, {
    path: '/partyPlanet/selectTicket',
    name: 'PartyPlanetSelectTicket',
    component: function component() {
      return import('views/partyPlanet/SelectTicket');
    },
    meta: {
      title: '选择票种'
    }
  }, {
    path: '/partyPlanet/order',
    name: 'PartyPlanetOrder',
    component: function component() {
      return import('views/partyPlanet/order/Index');
    },
    meta: {
      title: '我的活动',
      keepAlive: true
    }
  }, {
    path: '/partyPlanet/order/takeTicket',
    name: 'PartyPlanetTakeTicket',
    component: function component() {
      return import('views/partyPlanet/order/TakeTicket');
    },
    meta: {
      title: '取电子票'
    }
  }, {
    path: '/partyPlanet/chargeOff',
    name: 'PartyPlanetChargeOff',
    component: function component() {
      return import('views/partyPlanet/chargeOff/Index');
    },
    meta: {
      title: '核销门票'
    }
  }, {
    path: '/partyPlanet/chargeOff/input',
    name: 'PartyPlanetChargeOffInput',
    component: function component() {
      return import('views/partyPlanet/chargeOff/Input');
    },
    meta: {
      title: '核销门票'
    }
  }, {
    path: '/partyPlanet/chargeOff/detail',
    name: 'PartyPlanetChargeOffDetail',
    component: function component() {
      return import('views/partyPlanet/chargeOff/Detail');
    },
    meta: {
      title: '核销门票'
    }
  }]
};
export default copyrightCollect;